// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActorAnalyticsCard_abluft__OuxEJ {
    width: 92px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 17px;
    flex-shrink: 0;
}
.ActorAnalyticsCard_name__xAHua {
    border-radius: 5px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 9px 21px;
}
.ActorAnalyticsCard_statusIcon__8UpG9 {
    width: 55px;
    position: relative;
    border-radius: 5px;
    height: 49px;
    overflow: hidden;
    flex-shrink: 0;
}
.ActorAnalyticsCard_frameTop__LflQx {
    width: 210px;
    border-radius: 5px;
    background: linear-gradient(76.94deg, #4c7abe, #3e2e30 47.81%, #311414 85.5%, #5b4e54);
    border: 3px solid #33ff00;
    box-sizing: border-box;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
}
.ActorAnalyticsCard_auto__vnoxI {
    width: 48px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 23px;
    flex-shrink: 0;
}
.ActorAnalyticsCard_frameAuto__BSluy {
    width: 47px;
    border-radius: 5px;
    background-color: #fff;
    border: 1px solid #000;
    box-sizing: border-box;
    height: 31px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 1px;
    color: #000;
}
.ActorAnalyticsCard_frameOn__PGCRf {
    width: 47px;
    border-radius: 5px;
    background-color: #fff;
    border: 1px solid #000;
    box-sizing: border-box;
    height: 31px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 1px;
}
.ActorAnalyticsCard_frameMiddle__sNXJL {
    width: 165px;
    border-radius: 5px;
    background: linear-gradient(103.21deg, #4c7abe, #3e2e30 47.81%, #311414 85.5%, #5b4e54);
    height: 41px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    color: #859584;
}
.ActorAnalyticsCard_steuerartMesswerte__Udkh8 {
    margin: 0;
}
.ActorAnalyticsCard_steuerartMesswerteSteuerzieContainer1__1gAsq {
    width: 100%;
}
.ActorAnalyticsCard_steuerartMesswerteSteuerzieContainer__DLgTI {
    width: 207px;
    position: relative;
    display: flex;
    align-items: center;
    height: 140px;
    flex-shrink: 0;
}
.ActorAnalyticsCard_frameTop1__WJYR9 {
    width: 210px;
    border-radius: 5px;
    background: linear-gradient(27.84deg, #4c7abe, #3e2e30 47.81%, #311414 85.5%, #5b4e54);
    height: 140px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.ActorAnalyticsCard_aktorcard__\\+ZFvo {
    width: 100%;
    position: relative;
    border-radius: 5px;
    background-color: #05070a;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: 12px 0px;
    box-sizing: border-box;
    gap: 6px;
    text-align: center;
    font-size: 15px;
    color: #fff;
    font-family: Inter;
}

.ActorAnalyticsCard_frameTopRed__3O0QB {
    width: 100%;
    position: relative;
    border-radius: 5px;
    background: linear-gradient(76.94deg, #4c7abe, #3e2e30 47.81%, #311414 85.5%, #5b4e54);
    border: 3px solid #ff0000;
    box-sizing: border-box;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    text-align: center;
    font-size: 15px;
    color: #fff;
    font-family: Inter;
}`, "",{"version":3,"sources":["webpack://./src/css/ActorAnalyticsCard.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,sFAAsF;IACtF,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,uFAAuF;IACvF,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;AAClB;AACA;IACI,SAAS;AACb;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,cAAc;AAClB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,sFAAsF;IACtF,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,sFAAsF;IACtF,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".abluft {\n    width: 92px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 17px;\n    flex-shrink: 0;\n}\n.name {\n    border-radius: 5px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: 9px 21px;\n}\n.statusIcon {\n    width: 55px;\n    position: relative;\n    border-radius: 5px;\n    height: 49px;\n    overflow: hidden;\n    flex-shrink: 0;\n}\n.frameTop {\n    width: 210px;\n    border-radius: 5px;\n    background: linear-gradient(76.94deg, #4c7abe, #3e2e30 47.81%, #311414 85.5%, #5b4e54);\n    border: 3px solid #33ff00;\n    box-sizing: border-box;\n    overflow: hidden;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n}\n.auto {\n    width: 48px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 23px;\n    flex-shrink: 0;\n}\n.frameAuto {\n    width: 47px;\n    border-radius: 5px;\n    background-color: #fff;\n    border: 1px solid #000;\n    box-sizing: border-box;\n    height: 31px;\n    overflow: hidden;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: 1px;\n    color: #000;\n}\n.frameOn {\n    width: 47px;\n    border-radius: 5px;\n    background-color: #fff;\n    border: 1px solid #000;\n    box-sizing: border-box;\n    height: 31px;\n    overflow: hidden;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: 1px;\n}\n.frameMiddle {\n    width: 165px;\n    border-radius: 5px;\n    background: linear-gradient(103.21deg, #4c7abe, #3e2e30 47.81%, #311414 85.5%, #5b4e54);\n    height: 41px;\n    overflow: hidden;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    color: #859584;\n}\n.steuerartMesswerte {\n    margin: 0;\n}\n.steuerartMesswerteSteuerzieContainer1 {\n    width: 100%;\n}\n.steuerartMesswerteSteuerzieContainer {\n    width: 207px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    height: 140px;\n    flex-shrink: 0;\n}\n.frameTop1 {\n    width: 210px;\n    border-radius: 5px;\n    background: linear-gradient(27.84deg, #4c7abe, #3e2e30 47.81%, #311414 85.5%, #5b4e54);\n    height: 140px;\n    overflow: hidden;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n.aktorcard {\n    width: 100%;\n    position: relative;\n    border-radius: 5px;\n    background-color: #05070a;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    align-content: flex-start;\n    padding: 12px 0px;\n    box-sizing: border-box;\n    gap: 6px;\n    text-align: center;\n    font-size: 15px;\n    color: #fff;\n    font-family: Inter;\n}\n\n.frameTopRed {\n    width: 100%;\n    position: relative;\n    border-radius: 5px;\n    background: linear-gradient(76.94deg, #4c7abe, #3e2e30 47.81%, #311414 85.5%, #5b4e54);\n    border: 3px solid #ff0000;\n    box-sizing: border-box;\n    overflow: hidden;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    text-align: center;\n    font-size: 15px;\n    color: #fff;\n    font-family: Inter;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"abluft": `ActorAnalyticsCard_abluft__OuxEJ`,
	"name": `ActorAnalyticsCard_name__xAHua`,
	"statusIcon": `ActorAnalyticsCard_statusIcon__8UpG9`,
	"frameTop": `ActorAnalyticsCard_frameTop__LflQx`,
	"auto": `ActorAnalyticsCard_auto__vnoxI`,
	"frameAuto": `ActorAnalyticsCard_frameAuto__BSluy`,
	"frameOn": `ActorAnalyticsCard_frameOn__PGCRf`,
	"frameMiddle": `ActorAnalyticsCard_frameMiddle__sNXJL`,
	"steuerartMesswerte": `ActorAnalyticsCard_steuerartMesswerte__Udkh8`,
	"steuerartMesswerteSteuerzieContainer1": `ActorAnalyticsCard_steuerartMesswerteSteuerzieContainer1__1gAsq`,
	"steuerartMesswerteSteuerzieContainer": `ActorAnalyticsCard_steuerartMesswerteSteuerzieContainer__DLgTI`,
	"frameTop1": `ActorAnalyticsCard_frameTop1__WJYR9`,
	"aktorcard": `ActorAnalyticsCard_aktorcard__+ZFvo`,
	"frameTopRed": `ActorAnalyticsCard_frameTopRed__3O0QB`
};
export default ___CSS_LOADER_EXPORT___;
